import React, { useState, useEffect } from 'react';
import { Dialog } from "@mui/material";
import Spinner from '../../Spinner';
import { useAlertsContext } from '../../../contexts/AlertsContext';
import axios from 'axios';
import { useUserContext } from '../../../contexts/UserContext';
import checkIcon from '../../../assets/icons/check-icon.png';
import '../Fires/Modals/FiresModal.scss';

export default function AlertsModal(props) {
    const {
        getToken
    } = useUserContext();
    
    const {
        alerts,
        setAlerts
    } = useAlertsContext();

    const {
        setModal,
        modal
    } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [alert, setAlert] = useState(null);

    const fireId = modal.content?.fireId;
    const areaId = modal.content?.areaId;

    useEffect(() => {
        if (fireId && alerts.filter((a) => a.incident_id === fireId).length > 0) {
            setAlert(alerts.filter((a) => a.incident_id === fireId)[0]);
        } else if (areaId && alerts.filter((a) => a && a.area_id === areaId).length > 0) {
            setAlert(alerts.filter((a) => a && a.area_id === areaId)[0]);
        }
    }, [alerts, fireId, areaId]);

    const turnOnNotifications = (id, type) => {
        setLoading(true);
        setError(false);
        
        getToken()
        .then((token) => {
            const payload = type === 'fire' 
                ? { team_id: null, area_id: null, incident_id: id }
                : { team_id: null, area_id: id, incident_id: null };
                
            axios.post('https://firewatch-api.space-eyes.com/user/notifications', payload, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                console.log('Alert created:', response.data);
                setAlerts([
                    ...alerts.filter((a) => a && a.id !== response.data.id),
                    response.data
                ]);
                setAlert(response.data);
                setLoading(false);
            }).catch((error) => {
                console.log('error turning on notifications', error);
                setLoading(false);
                setError('Trouble turning on notifications. Please try again.')
            })
        })
        .catch((error) => {
            console.error('Failed to get token:', error);
            setError('Trouble turning on notifications. Please try again.')
        });
    }

    const turnOffNotifications = (alertID) => {
        setLoading(true);
        setError(false);
        
        getToken()
        .then((token) => {
            axios.delete(`https://firewatch-api.space-eyes.com/user/notifications?id=${alertID}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                console.log('Alert deleted:', response.data);
                setAlerts(alerts.filter((a) => a.id !== alertID));
                setAlert(null);
                setLoading(false);
            }).catch((error) => {
                console.log('error turning off notifications', error);
                setLoading(false);
                setError('Trouble turning off notifications. Please try again.')
            })
        })
        .catch((error) => {
            console.error('Failed to get token:', error);
            setError('Trouble turning off notifications. Please try again.')
        });
    }

    const getModalTitle = () => {
        if (fireId) return 'Fire Specific Alerts';
        if (areaId) return 'Monitoring Area Alerts';
        return 'Alerts';
    }

    const getModalDescription = () => {
        if (fireId) return 'Receive real-time email alerts everytime there is an update to this specific fire.';
        if (areaId) return 'Receive real-time email alerts when a new fire or fire prediction is detected in your Monitoring Area.';
        return 'Manage your alerts.';
    }

    const handleTurnOn = () => {
        if (fireId) {
            turnOnNotifications(fireId, 'fire');
        } else if (areaId) {
            turnOnNotifications(areaId, 'area');
        }
    }

    const handleTurnOff = () => {
        if (alert) {
            turnOffNotifications(alert.id);
        }
    }

    return (
        <Dialog
            open={modal.type}
            onClose={() => {
                if (modal.type) {
                    setModal({
                        type: false,
                        content: null
                    })
                }
            }}
            PaperProps={{
                sx: {
                  backgroundColor: "white",
                }
              }}
        >
            <div className='fires-modal'>
                <div className='fires-modal-title'>{getModalTitle()}</div>
                <div className='fires-modal-content'>
                    <div className='fires-modal-content-text'>{getModalDescription()}</div>
                    {areaId && (
                        <div className='fires-modal-content-alert'>
                            <div className='fires-modal-content-alert-top'>
                                <div className='fires-modal-content-alert-top-text'>Email</div>
                                <img src={checkIcon} className='fires-modal-content-alert-top-icon'/>
                            </div>
                            <div className='fires-modal-content-alert-bottom'>cesar@space-eyes.com</div>
                        </div>
                    )}
                </div>
                {error && <div className='fires-modal-content-error'>{error}</div>}
                {loading ?
                <div style={{ paddingTop: '1rem' }}>
                    <Spinner />
                </div>
                :
                <div className='fires-modal-content-alert-btns'>
                    {!alert ?
                    <div 
                        className='fires-modal-content-alert-btns-btn-save'
                        onClick={handleTurnOn}
                        >
                     Turn On
                    </div>
                    :
                    <div 
                        className='fires-modal-content-alert-btns-btn-off'
                        onClick={handleTurnOff}
                        >
                     Turn Off
                    </div>
                    }
                    <div 
                        className='fires-modal-content-alert-btns-btn-cancel'
                        onClick={() => {
                            setModal({
                                type: false,
                                content: null
                            })
                        }}
                        >
                        Cancel
                    </div>
                </div>
                }
            </div>
        </Dialog>
    )
}
